import axios from 'axios';

const ROOT = 'api/v1/patients-database';

const PatientDatabaseApi = {
  getPatientsByFilters(request) {
    return axios.post(`${ROOT}/search`, request);
  },
  getPatientsCountByFilters(request) {
    return axios.post(`${ROOT}/search/count`, request, { hideLoader: true });
  },
  getStudySites() {
    return axios.get(`${ROOT}/study-sites`, { hideLoader: true });
  },
  getActiveAndEnrollingStudySites() {
    return axios.get(`${ROOT}/study-sites/active-and-enrolling`, { hideLoader: true });
  },
  pushToPreScreening(payload) {
    return axios.post(`${ROOT}/push-to-pre-screening`, payload);
  },
  updateLeadStatus(id, status) {
    return axios.patch(`${ROOT}/${id}/lead-status`, { status });
  }
};

export default PatientDatabaseApi;
